var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearnerDashboardChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5144_11710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8164 42.6045C25.7344 43.2313 24.4002 43.2332 23.3164 42.6096L8.11332 33.8612C7.02952 33.2376 6.36076 32.0831 6.35896 30.8327L6.33371 13.2922C6.33191 12.0418 6.99734 10.8854 8.07935 10.2586L23.2572 1.46653C24.3392 0.839761 25.6734 0.837841 26.7572 1.46149L41.9603 10.2098C43.0441 10.8335 43.7128 11.988 43.7146 13.2384L43.7399 30.7789C43.7417 32.0293 43.0763 33.1857 41.9943 33.8125L26.8164 42.6045Z",
    fill: "white",
    stroke: "#100F0F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5144_11710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0548 38.7547C24.6742 39.111 25.4366 39.1099 26.0548 38.7518L39.0245 31.2389C39.6427 30.8807 40.023 30.2199 40.022 29.5054L40.0004 14.5169C39.9994 13.8024 39.6172 13.1427 38.9979 12.7863L26.0067 5.31074C25.3874 4.95437 24.625 4.95547 24.0067 5.31362L11.0371 12.8265C10.4188 13.1847 10.0386 13.8455 10.0396 14.56L10.0612 29.5485C10.0622 30.263 10.4444 30.9227 11.0637 31.2791L24.0548 38.7547Z",
    fill: "url(#paint0_linear_5144_11710)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_5144_11710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0548 38.7547C24.6742 39.111 25.4366 39.1099 26.0548 38.7518L39.0245 31.2389C39.6427 30.8807 40.023 30.2199 40.022 29.5054L40.0004 14.5169C39.9994 13.8024 39.6172 13.1427 38.9979 12.7863L26.0067 5.31074C25.3874 4.95437 24.625 4.95547 24.0067 5.31362L11.0371 12.8265C10.4188 13.1847 10.0386 13.8455 10.0396 14.56L10.0612 29.5485C10.0622 30.263 10.4444 30.9227 11.0637 31.2791L24.0548 38.7547Z",
    fill: "url(#paint1_linear_5144_11710)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5144_11710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5349 14.8502C24.6839 14.3893 25.3356 14.3884 25.4859 14.8488L26.846 19.0141C26.9132 19.22 27.1054 19.3592 27.322 19.3589L31.7037 19.3526C32.1881 19.3519 32.3903 19.9714 31.9989 20.2567L28.4577 22.8373C28.2827 22.9649 28.2097 23.1907 28.2769 23.3966L29.6369 27.5619C29.7873 28.0223 29.2606 28.4062 28.8683 28.122L25.3197 25.5516C25.1443 25.4246 24.907 25.4249 24.7319 25.5525L21.1908 28.1331C20.7993 28.4183 20.2715 28.036 20.4205 27.5752L21.7686 23.406C21.8352 23.1999 21.7615 22.9743 21.5861 22.8472L18.0375 20.2768C17.6453 19.9927 17.8458 19.3726 18.3301 19.3719L22.7118 19.3656C22.9284 19.3653 23.1202 19.2255 23.1869 19.0194L24.5349 14.8502Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5144_11710",
    x: 0.832031,
    y: 0.495102,
    width: 43.4062,
    height: 46.0809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5144_11710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5144_11710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5144_11710",
    x: 10.0391,
    y: 5.04424,
    width: 29.9844,
    height: 34.9769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5144_11710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_5144_11710",
    x: 10.0391,
    y: 5.04424,
    width: 29.9844,
    height: 34.9769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5144_11710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5144_11710",
    x: 12.8281,
    y: 12.504,
    width: 20.3789,
    height: 19.7272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5144_11710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5144_11710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5144_11710",
    x1: 25.0646,
    y1: 45.5084,
    x2: 25.0059,
    y2: 4.73483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5144_11710",
    x1: 25.0646,
    y1: 45.5084,
    x2: 25.0059,
    y2: 4.73483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8557"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnerDashboardChip);
export default __webpack_public_path__ + "static/media/learnerDashboardChip.c7c8e34ec0a8366c43fadb6bb1a5faf2.svg";
export { ForwardRef as ReactComponent };